import React from "react";

export const ScorecardIcon = ({
  isActive,
  opacity,
  ...props
}: SvgIconProps) => {
  return (
    <svg width={14} height={14} viewBox="0 0 11 14" fill="none" {...props}>
      <path
        d="M10 13V5.5M5.5 13V1M1 13V8.5"
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={opacity}
      />
    </svg>
  );
};
